import { css } from '@emotion/react';

import { Bar, SpinnerContainer } from './AnimatedSpinner.styles';

const barStyles = (rotate: number, delay: number) => css`
  transform: rotate(${rotate}deg) translate(0, -130%);
  animation-delay: ${delay}s;
`;

type AnimatedSpinnerProps = {
  size?: number;
};

export const AnimatedSpinner = ({ size = 24 }: AnimatedSpinnerProps) => (
  <SpinnerContainer size={size}>
    <Bar css={barStyles(0, 0)} />
    <Bar css={barStyles(30, -0.9167)} />
    <Bar css={barStyles(60, -0.833)} />
    <Bar css={barStyles(90, -0.7497)} />
    <Bar css={barStyles(120, -0.667)} />
    <Bar css={barStyles(150, -0.5837)} />
    <Bar css={barStyles(180, -0.5)} />
    <Bar css={barStyles(210, -0.4167)} />
    <Bar css={barStyles(240, -0.333)} />
    <Bar css={barStyles(270, -0.2497)} />
    <Bar css={barStyles(300, -0.167)} />
    <Bar css={barStyles(330, -0.0833)} />
  </SpinnerContainer>
);
